import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Tooltip,
} from "antd";
import Table from "components/ResizableTable";

import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { styled } from "styled-components";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import Utils from "utils";
import {
  addNewNhapKhoCT,
  getNhapKhoCTByManx,
  setNhapKhoCTList,
  updateNhapKhoCT,
  deleteNhapKhoCT,
  getHangHoaNhapKho,
} from "store/slices/sale/nhapkhoSlice";

import { initNhapKhoCt } from "views/app-views/sale/managements/QuanLyKho/NhapKho";
import { isEmpty } from "lodash";
import { substr } from "stylis";
import moment from "moment";
import { dateFormatList } from "constants";
import { getDmdonvichuyendoiDto } from "store/slices/sale/danhmucSlice";
import { THUE_SUAT } from "constants";

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    if (record["action"] !== "initial" && record["action"] !== "update") {
      return;
    }

    if (
      record["action"] !== "initial" &&
      (dataIndex === "tenhh" || dataIndex === "maview")
    ) {
      return;
    }

    if (dataIndex === "tenhh" || dataIndex === "maview") {
      restProps.dispatch(
        getHangHoaNhapKho({
          manx: restProps.nhapKhoId,
          makk: restProps.makk,
          ngay: new Date(restProps.ngay),
        }),
      );
    }
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });

    if (dataIndex === "handung") {
      if (record["action"] !== "initial" && record["handung"] !== null) {
        form.setFieldValue([dataIndex], moment(record["handung"]));
      } else {
        form.setFieldValue([dataIndex], null);
      }
    }
  };
  const onChangeTenhh = (value) => {
    if (value === null) return;
    const data = restProps.hangHoaNhapKhoList.find((i) => i.mahh === value);
    restProps.setMahhdachon(value);
    form.setFieldValue([dataIndex], data.tenhh);
    handleSave(
      {
        ...record,
        mahh: data.mahh,
        maview: data.maview,
        mathamchieu: data.mathamchieu,
        tenhh: data.tenhh,
        quycachdonggoi: data.quycachdonggoi,
        tendonvitinh: data.tenDonViTinh,
        sodangky: data.sodangky,
        dongia: data.dongia,
        tknoid: restProps.dinhKhoanCate?.find((f) => f.soTaiKhoan === "156")
          ?.id,
        tkcoid: restProps.dinhKhoanCate?.find((f) => f.soTaiKhoan === "331")
          ?.id,
      },
      dataIndex,
    );
  };
  const onChangeMaview = (value) => {
    if (value === null) return;
    const data = restProps.hangHoaNhapKhoList.find((i) => i.mahh === value);
    restProps.setMahhdachon(value);
    form.setFieldValue([dataIndex], data.maview);
    handleSave(
      {
        ...record,
        mahh: data.mahh,
        maview: data.maview,
        mathamchieu: data.mathamchieu,
        tenhh: data.tenhh,
        quycachdonggoi: data.quycachdonggoi,
        tendonvitinh: data.tenDonViTinh,
        sodangky: data.sodangky,
        dongia: data.dongia,
        tknoid: restProps.dinhKhoanCate?.find((f) => f.soTaiKhoan === "156")
          ?.id,
        tkcoid: restProps.dinhKhoanCate?.find((f) => f.soTaiKhoan === "331")
          ?.id,
      },
      dataIndex,
    );
  };

  const onChangeDVT = (value) => {
    if (value === null) return;
    const data = restProps.DmdonvichuyendoiDtoList.find(
      (i) => i.machuyendoi === value,
    );
    form.setFieldValue([dataIndex], data.tendonvitinh);
    handleSave(
      {
        ...record,
        machuyendoi: value,
        tendonvitinh: data.tendonvitinh,
      },
      dataIndex,
    );
  };
  const onChangeHanDung = (date, dates) => {
    if (date === null) {
      restProps.setEditHSD(false);
    } else {
      restProps.setEditHSD(true);
    }
  };
  const onChangeSoLuong = (value) => {
    if (value === null) return;
    handleSave(
      {
        ...record,
        thanhtien: record.dongia * value,
      },
      dataIndex,
    );
  };
  const onChangeThanhTien = (value) => {
    if (value === null) return;
    if (record.soluong === null || record.soluong <= 0) return;
    handleSave(
      {
        ...record,
        dongia: value / record.soluong,
      },
      dataIndex,
    );
  };

  const onChangeDonGia = (value) => {
    if (value === null) return;
    handleSave(
      {
        ...record,
        thanhtien: record.soluong * value,
      },
      dataIndex,
    );
  };

  const onChangeTk = (value, obj) => {
    if (value === null) return;
    if (obj === "tknoid")
      handleSave(
        {
          ...record,
          tknoid: value,
        },
        dataIndex,
      );
    else
      handleSave(
        {
          ...record,
          tkcoid: value,
        },
        dataIndex,
      );
  };

  const onChangeThue = (value, obj) => {
    if (value === null) return;

    handleSave(
      {
        ...record,
        thuect: value,
      },
      dataIndex,
    );
  };

  const onChangeChietKhau = (value, obj) => {
    if (value === null) return;

    handleSave(
      {
        ...record,
        chietkhauct: value,
      },
      dataIndex,
    );
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values }, dataIndex);
    } catch (errInfo) {}
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
      >
        {dataIndex === "handung" ? (
          <DatePicker
            format={dateFormatList}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            placeholder="Hạn dùng"
            onChange={(date, dates) => onChangeHanDung(date, dates)}
          />
        ) : dataIndex === "soluong" ? (
          <InputNumber
            style={{ width: "100%" }}
            step={1}
            formatter={(value) => Utils.formatterNumber(value)}
            parser={(value) => parserNumber(value)}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeSoLuong(value)}
          />
        ) : dataIndex === "thanhtien" ? (
          <InputNumber
            style={{ width: "100%" }}
            step={1}
            formatter={(value) => Utils.formatterNumber(value)}
            parser={(value) => parserNumber(value)}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeThanhTien(value)}
          />
        ) : dataIndex === "dongia" ? (
          <InputNumber
            style={{ width: "100%" }}
            step={1}
            formatter={(value) => Utils.formatterNumber(value)}
            parser={(value) => parserNumber(value)}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeDonGia(value)}
          />
        ) : dataIndex === "tenhh" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn thuốc vật tư"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeTenhh(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 900,
            }}
          >
            {restProps.hangHoaNhapKhoList.map((x) => (
              <Select.Option label={x.tenhh} value={x.mahh} key={x.mahh}>
                <div style={{ display: "flex" }}>
                  {/* <Image
                    src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg"
                    style={{ width: 50, height: 50 }}
                  /> */}
                  <table style={{ borderCollapse: "collapse", width: "850px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <th
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mã nội bộ
                      </th>
                      <th
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tên thuốc vật tư
                      </th>
                      <th
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Quy cách
                      </th>
                      <th
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Đơn giá
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "650px" }}>
                      <td
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mathamchieu}>
                          {substr(x.mathamchieu, 0, 12) +
                            (x.mathamchieu.length > 12 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tenhh}>
                          {substr(x.tenhh, 0, 50) +
                            (x.tenhh.length > 50 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.quycachdonggoi}
                      </td>
                      <td
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.tenDonViTinh}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        {Utils.formatterNumber(x.dongia)}
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : dataIndex === "mathamchieu" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn thuốc vật tư"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeMaview(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 900,
            }}
          >
            {restProps.hangHoaNhapKhoList.map((x) => (
              <Select.Option label={x.maview} value={x.mahh} key={x.mahh}>
                <div style={{ display: "flex" }}>
                  {/* <Image
                    src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg"
                    style={{ width: 50, height: 50 }}
                  /> */}
                  <table style={{ borderCollapse: "collapse", width: "850px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <th
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mã nội bộ
                      </th>
                      <th
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tên thuốc vật tư
                      </th>
                      <th
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Quy cách
                      </th>
                      <th
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Đơn giá
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mathamchieu}>
                          {substr(x.mathamchieu, 0, 12) +
                            (x.mathamchieu.length > 12 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tenhh}>
                          {substr(x.tenhh, 0, 50) +
                            (x.tenhh.length > 50 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.quycachdonggoi}
                      </td>
                      <td
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.tenDonViTinh}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        {Utils.formatterNumber(x.dongia)}
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : dataIndex === "tknoid" || dataIndex === "tkcoid" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn tài khoản"
            showSearch
            onChange={(c) => onChangeTk(c, dataIndex)}
            optionFilterProp="children"
            onPressEnter={save}
            onBlur={save}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            options={restProps.dinhKhoanCate.map((m) => ({
              value: m.id,
              label: `${m.soTaiKhoan} - ${m.tenTaiKhoan}`,
            }))}
          />
        ) : dataIndex === "tendonvitinh" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn đơn vị tính"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeDVT(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 500,
            }}
          >
            {restProps.DmdonvichuyendoiDtoList.map((x) => (
              <Select.Option
                label={x.tendonvitinh}
                value={x.machuyendoi}
                key={x.machuyendoi}
              >
                <div style={{ display: "flex" }}>
                  <table style={{ borderCollapse: "collapse", width: "250px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "250px" }}>
                      <th
                        style={{
                          width: "70px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mô tả
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "250px" }}>
                      <td
                        style={{
                          width: "70px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tendonvitinh}>
                          {x.tendonvitinh}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mota}>{x.mota}</Tooltip>
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : dataIndex === "thuect" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn thuế"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeThue(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 500,
            }}
            options={THUE_SUAT}
          />
        ) : dataIndex === "chietkhauct" ? (
          <InputNumber
            style={{ width: "100%" }}
            step={1}
            formatter={(value) => Utils.formatterNumber(value)}
            parser={(value) => parserNumber(value)}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeChietKhau(value)}
          />
        ) : (
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 10,
          height: 20,
          width: "100%",
        }}
        onClick={toggleEdit}
      >
        {restProps.isDate
          ? record.handung
            ? dayjs(record.handung).format("DD/MM/YYYY")
            : null
          : children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

export const parserNumber = (val) => {
  if (!val) return 0;
  return Number.parseFloat(
    val.replace(/\$\s?|(\.*)/g, "").replace(/(,{1})/g, "."),
  ).toFixed(5);
};
export default function TablenhapKhoCTList({
  setNhapKhoId,
  nhapKhoCTList,
  setVisibleModal,
  visibleModal,
  reloadData,
  dmThuocVatTuList,
  nhapKhoId,
  permitList = [],
  maKknhap,
  ngaynhap,
}) {
  const dispatch = useDispatch();
  const [editHSD, setEditHSD] = useState(false);
  const { hangHoaNhapKhoList } = useSelector((state) => state.nhapKhoSale);
  const onClickCancelAction = (record, index) => {
    setEditHSD(false);
    const newData = nhapKhoCTList.slice(0);
    const indexX = newData.findIndex((item) => record.manxct === item.manxct);
    newData[indexX] = { ...newData[indexX], action: "" };
    dispatch(setNhapKhoCTList(newData));
  };
  const [mahhdachon, setMahhdachon] = useState(null);
  const { DmdonvichuyendoiDtoList } = useSelector((state) => state.danhMucSale);

  useEffect(() => {
    if (mahhdachon === null || mahhdachon === 0) return;
    dispatch(getDmdonvichuyendoiDto(mahhdachon));
  }, [dispatch, mahhdachon]);

  const { dinhKhoanCate } = useSelector((state) => state.dinhKhoanCategory);
  const onClickAction = (record, index) => {
    const newData = nhapKhoCTList.slice(0);

    const payload = {
      manxct: record.manxct,
      mahh: record.mahh,
      tenhh: record.tenhh,
      maview: record.maview,
      losx: record.losx,
      handungtext:
        (record.action === "initial" &&
          (record.handung === null || !editHSD)) ||
        record.handung === null
          ? ""
          : Utils.formatDate(record.handung, true),
      dongia: record.dongia,
      thanhtien: record.thanhtien,
      soluong: record.soluong,
      manx: nhapKhoId,
      tknoid: record.tknoid,
      tkcoid: record.tkcoid,
      machuyendoi: record.machuyendoi,
      thuect: record.thuect,
      chietkhauct: record.chietkhauct,
      onSuccess: () => {
        dispatch(
          getNhapKhoCTByManx({
            manx: nhapKhoId,
            isNewCt: record.action === "initial",
          }),
        );
      },
    };
    setEditHSD(false);

    setMahhdachon(record.mahh);

    if (isEmpty(payload.tenhh)) {
      return;
    }
    if (record.action === initNhapKhoCt.action) {
      dispatch(addNewNhapKhoCT(payload));
    } else {
      if (record.manxct !== null && record.action !== "update") {
        const indexX = newData.findIndex(
          (item) => record.manxct === item.manxct,
        );
        newData[indexX] = { ...newData[indexX], action: "update" };
        dispatch(setNhapKhoCTList(newData));
      } else {
        dispatch(updateNhapKhoCT(payload));
      }
    }
  };

  const tableColumns = useMemo(
    () => [
      {
        title: "STT",
        width: 40,
        align: "center",
        dataIndex: "thuTu",
      },
      {
        title: "Mã nội bộ",
        width: 100,
        dataIndex: "mathamchieu",
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.mathamchieu}>
            <div>
              {!isEmpty(record.mathamchieu) ? (
                record.mathamchieu.substr(0, 15) +
                (record.mathamchieu?.length > 15 ? "..." : "")
              ) : (
                <i
                  style={{
                    fontSize: "16px",
                    color: "blue",
                    paddingLeft: "20px",
                  }}
                >
                  ...
                </i>
              )}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Tên thuốc, vật tư",
        width: 180,
        dataIndex: "tenhh",
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.tenhh}>
            <div>
              {!isEmpty(record.tenhh) ? (
                record.tenhh.substr(0, 45) +
                (record.tenhh?.length > 45 ? "..." : "")
              ) : (
                <i
                  style={{
                    fontSize: "16px",
                    color: "blue",
                    paddingLeft: "10px",
                  }}
                >
                  Chọn hàng hóa...
                </i>
              )}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Quy cách",
        dataIndex: "quycachdonggoi",
        width: 80,
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.quycachdonggoi}>
            {record.quycachdonggoi}
          </Tooltip>
        ),
      },
      {
        title: "ĐVT",
        dataIndex: "tendonvitinh",
        width: 60,
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.tendonvitinh}>{record.tendonvitinh}</Tooltip>
        ),
      },

      {
        title: "Lô SX",
        width: 70,
        dataIndex: "losx",
        editable: true,
      },
      {
        title: "HSD",
        width: 90,
        dataIndex: "handung",
        isDate: true,
        editable: true,
        align: "center",
      },
      // {
      //   title: "Tk nợ",
      //   width: 120,
      //   dataIndex: "tknoid",
      //   editable: true,
      //   render: (e, r, i) => dinhKhoanCate?.find((f) => f.id === e)?.tenView,
      // },
      // {
      //   title: "Tk có",
      //   width: 120,
      //   dataIndex: "tkcoid",
      //   editable: true,
      //   render: (e, r, i) => dinhKhoanCate?.find((f) => f.id === e)?.tenView,
      // },
      {
        title: "Số lượng",
        width: 100,
        dataIndex: "soluong",
        align: "right",
        editable: true,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Đơn giá",
        width: 100,
        dataIndex: "dongia",
        align: "right",
        editable: true,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Thành tiền",
        width: 100,
        dataIndex: "thanhtien",
        align: "right",
        editable: true,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Chiết khấu",
        width: 100,
        dataIndex: "chietkhauct",
        editable: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Thuế (%)",
        width: 80,
        dataIndex: "thuect",
        editable: true,
        render: (e, r, i) => THUE_SUAT?.find((f) => f.value === e)?.label,
      },
      {
        title: "Tiền thuế",
        width: 90,
        dataIndex: "thanhtienthue",
        align: "right",
        editable: false,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Đơn giá sau thuế",
        width: 100,
        dataIndex: "dongiathue",
        align: "right",
        editable: false,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Thành Tiền sau thuế",
        width: 100,
        dataIndex: "thanhtienxuat",
        align: "right",
        editable: false,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        fixed: "right",
        width: 120,
        align: "center",
        dataIndex: "action",
        render: (_, record, index) => (
          <>
            {record.action === "initial" ? (
              <Button
                disabled={
                  !record.tenhh || nhapKhoId === null || nhapKhoId === 0
                }
                title={"Thêm chi tiết"}
                onClick={() => onClickAction(record, index)}
                className="mr-2"
                icon={<PlusOutlined />}
                shape="circle"
              />
            ) : record.action === "update" ? (
              <>
                <Button
                  title="Lưu chi tiết"
                  disabled={
                    nhapKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.manxct !==
                      nhapKhoCTList.filter((x) => x.action === "update")[0]
                        ?.manxct
                  }
                  onClick={() => onClickAction(record, index)}
                  className="mr-2"
                  icon={<SaveOutlined />}
                  shape="circle"
                />
                <Button
                  title="Hủy"
                  disabled={
                    nhapKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.manxct !==
                      nhapKhoCTList.filter((x) => x.action === "update")[0]
                        ?.manxct
                  }
                  onClick={() => onClickCancelAction(record, index)}
                  className="mr-2"
                  icon={<CloseOutlined />}
                  shape="circle"
                />
              </>
            ) : (
              <>
                <Button
                  title="Sửa chi tiết"
                  disabled={
                    nhapKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.manxct !==
                      nhapKhoCTList.filter((x) => x.action === "update")[0]
                        ?.manxct
                  }
                  onClick={() => onClickAction(record, index)}
                  className="mr-2"
                  icon={<EditOutlined />}
                  shape="circle"
                />
                <Popconfirm
                  title="Bạn có muốn xóa chi tiết?"
                  placement="topLeft"
                  onConfirm={() => {
                    dispatch(
                      deleteNhapKhoCT({
                        id: record.manxct,
                        onSuccess: () => {
                          dispatch(
                            getNhapKhoCTByManx({
                              manx: nhapKhoId,
                              isNewCt: false,
                            }),
                          );
                        },
                      }),
                    );
                  }}
                >
                  <Button
                    title={"Xóa chi tiết"}
                    disabled={
                      nhapKhoCTList.filter((x) => x.action === "update")
                        .length > 0 &&
                      record.manxct !==
                        nhapKhoCTList.filter((x) => x.action === "update")[0]
                          ?.manxct
                    }
                    className="mr-2"
                    icon={<DeleteOutlined type="primary" />}
                    shape="circle"
                  />
                </Popconfirm>
              </>
            )}
          </>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nhapKhoCTList],
  );

  const handleSave = (row) => {
    const newData = nhapKhoCTList.slice(0);
    const index = newData.findIndex((item) => row.manxct === item.manxct);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    dispatch(setNhapKhoCTList(newData));
  };

  const columns = tableColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
        isDate: col.isDate,
        isMoney: col.isMoney,
        dmThuocVatTuList: dmThuocVatTuList,
        nhapKhoCTList: nhapKhoCTList,
        setEditHSD: setEditHSD,
        dispatch: dispatch,
        nhapKhoId: nhapKhoId,
        ngay: ngaynhap,
        makk: maKknhap,
        hangHoaNhapKhoList: hangHoaNhapKhoList,
        dinhKhoanCate: dinhKhoanCate,
        setMahhdachon: setMahhdachon,
        DmdonvichuyendoiDtoList: DmdonvichuyendoiDtoList,
      }),
    };
  });

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  return (
    <CustomTable
      components={components}
      columns={columns}
      dataSource={nhapKhoCTList}
      rowKey={(_, index) => index}
      style={{ padding: "0px" }}
      rowClassName="editable-row"
      tableLayout="fixed"
      pagination={false}
      scroll={{ x: "max-content", y: "400px" }}
      footer={(nhapKhoCTList) => (
        <div>
          <div>
            Số khoản:
            <b style={{ color: "green", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                nhapKhoCTList.filter((x) => x.manxct).length,
              )}
            </b>
          </div>
          <div>
            Tổng tiền:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                nhapKhoCTList
                  .filter((x) => x.manxct)
                  .reduce((prev, current) => prev + current?.thanhtien || 0, 0),
              )}
            </b>
            <span style={{ margin: "10px" }} />
            Tổng chiết khấu:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                nhapKhoCTList
                  .filter((x) => x.manxct)
                  .reduce(
                    (prev, current) => prev + current?.chietkhauct || 0,
                    0,
                  ),
              )}
            </b>
            <span style={{ margin: "10px" }} />
            Tổng tiền thuế:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                nhapKhoCTList
                  .filter((x) => x.manxct)
                  .reduce(
                    (prev, current) => prev + current?.thanhtienthue || 0,
                    0,
                  ),
              )}
            </b>
            <span style={{ margin: "10px" }} />
            Thành tiền sau thuế:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                nhapKhoCTList
                  .filter((x) => x.manxct)
                  .reduce(
                    (prev, current) =>
                      prev +
                        current?.thanhtien +
                        current?.thanhtienthue -
                        current?.chietkhauct || 0,
                    0,
                  ),
              )}
            </b>
          </div>
        </div>
      )}
    />
  );
}

const CustomTable = styled(Table)`
  // .ant-table-tbody > tr > td {
  //   padding: 2px;
  // }
`;
